<template>
  <div>
    <div class="productBar">
      <div class="auto clearfix">
        <h2 class="fl">
          产品：大智慧专业版
          <span>非投资咨询类软件产品</span>
        </h2>
        <div class="p-nav fr">
          <span :class="{'cur' :navIndex === index}" @click="navIndex = index" v-for="(item, index) in nav" :key="index">{{ item }}</span>
        </div>
      </div>
    </div>
    <div class="gnysCon" v-show="navIndex === 0">
      <div class="slogan">
        <router-link :to="'/order/confirm/' + id" class="buy">立刻购买</router-link>
      </div>
      <div class="auto">
        <div class="sub-slogan">
          <dl>
            <dt>我们只为投资者做两点</dt>
            <dd>提供专业的财务数据</dd>
            <dd>提供个性化编写股票池</dd>
          </dl>
          <dl>
            <dt>海量专业数据</dt>
            <dd>专业全面的上市公司财务数据，</dd>
            <dd>让您在数据的海洋中畅游</dd>
          </dl>
        </div>
        <div class="intro">
          <dl>
            <dt>私密选股策略</dt>
            <dd>个性化编写属于自己的选股策略</dd>
            <dd class="dd-img">
              <div class="div-img">
                <img src="../../assets/images/product/73/img03.jpg" />
              </div>
            </dd>
          </dl>
          <dl>
            <dt>概念选股引擎</dt>
            <dd>强大信息搜索引擎紧盯热点，捕捉概念龙头</dd>
            <dd class="dd-img">
              <div class="div-img">
                <img src="../../assets/images/product/73/img04.jpg"  />
              </div>
            </dd>
          </dl>
          <dl>
            <dt>资金密码</dt>
            <dd>不管是场内资金还是外围资金，抢筹个股一览无遗</dd>
            <dd class="dd-img">
              <div class="div-img">
                <img src="../../assets/images/product/73/img05.jpg" />
              </div>
            </dd>
          </dl>
          <dl>
            <dt>智能复盘</dt>
            <dd>梳理当天市场脉络，揭秘个股涨停原因，复盘庄家操作手法</dd>
            <dd class="dd-img">
              <div class="div-img">
                <img src="../../assets/images/product/73/img06.jpg" />
              </div>
            </dd>
          </dl>
          <dl>
            <dt>TS时间序列</dt>
            <dd>
              <p>按照国际算法，采用特定的时间序列，</p>来确定K线的上涨下跌结构。
            </dd>
            <dd class="dd-img">
              <div class="div-img">
                <img src="../../assets/images/product/73/img07.jpg" />
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="xxgnCon" v-show="navIndex === 1">
      <product-detail73 />
    </div>
    <float-bar :id="id" :month="month"/>
  </div>
</template>

<script>
import ProductDetail73 from "@/components/product/ProductDetail73.vue";
import FloatBar from "@/components/product/FloatBar.vue";
export default {
  data() {
    return {
      id: this.$parent.id,
      month : 12,
      nav: ["功能演示", "详细功能"],
      navIndex: 0
    };
  },
  created() {
    document.title = "大智慧专业版";
  },
  components: {
    ProductDetail73,
    FloatBar
  }
};
</script>
"~@/assets/images/pay/phone-bg.png"
<style lang="scss" scoped>
.gnysCon {
  background: url(~@/assets/images/product/73/bg01.jpg) repeat-y center top;
  .slogan {
    background: url(~@/assets/images/product/73/bg02.jpg) center top;
    @include wh(100%, 1061px);
    margin-bottom: 110px;
    a {
      display: block;
      @include vertical-center(284px, 80px);
      box-sizing: border-box;
      background: #002242;
      @include fc(34px, #47a6ff);
      border: 2px solid #47a6ff;
      border-radius: 48px;
      margin: 0 auto;
      position: relative;
      top: 894px;
    }
  }
  .sub-slogan {
    background: url(~@/assets/images/product/73/bg03.jpg) no-repeat top right;
    padding-bottom: 80px;
    dl {
      margin-bottom: 150px;
      dt {
        @include fc(65px, #1d92ff);
        margin-bottom: 25px;
        line-height: 1;
        &:before {
          content: "";
          display: inline-block;
          @include wh(10px, 10px);
          border-radius: 50%;
          background: #1d92ff;
          margin-right: 10px;
          vertical-align: middle;
        }
      }
      dd {
        @include fc(40px, #fff);
        line-height: 60px;
        text-indent: 25px;
      }
    }
  }
  .intro {
    padding-bottom: 50px;
    dl {
      padding-bottom: 75px;
    }
    dt {
      @include fc(60px, #fff);
      margin: 0 0 5px 66px;
      font-weight: bolder;
      position: relative;
      padding-left: 35px;
      &:before {
        content: "";
        display: inline-block;
        @include wh(10px, 50px);
        background: #fff;
        position: absolute;
        left: 0;
        top: 19px;
      }
    }
    dd {
      font-weight: 400;
      &:nth-of-type(1) {
        @include fc(40px, #fff);
        margin: 0px 0 40px 96px;
      }
    }
    .dd-img {
      border: 2px solid #07203a;
      border-radius: 15px;
      position: relative;
      box-sizing: border-box;
      width: 1180px;
      margin: 0 auto;
      &:before {
        content: "";
        display: inline-block;
        box-sizing: border-box;
        border: 3px solid #0f4a84;
        position: absolute;
        left: 25px;
        top: 25px;
        right: 25px;
        bottom: 25px;
        border-radius: 15px;
      }
      &:after {
        content: "";
        display: inline-block;
        box-sizing: border-box;
        border: 3px solid #1d92ff;
        position: absolute;
        left: 55px;
        top: 46px;
        right: 55px;
        bottom: 46px;
        border-radius: 15px;
      }
      .div-img {
        &:before {
          content: "";
          display: inline-block;
          @include wh(700px, 600px);
          box-sizing: border-box;
          position: absolute;
          right: 0px;
          top: 0px;
          background: radial-gradient(#1d92ff, rgba(255, 0, 0, 0) 80%);
          z-index: 0;
        }
        img {
          display: block;
          margin: 65px auto 70px;
          box-shadow: 0px 0px 18px rgba($color: #4896ff, $alpha: 0.4);
          position: relative;
          z-index: 2;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/Product73.vue